import { useCurrencies, useVatConfigurations } from '../../app-init-data';

enum CURRENCY_LIST {
	AED = 1,
}

const useCurrencyAndVat = () => {
	const { vatConfigurations } = useVatConfigurations();
	const { currencies } = useCurrencies();

	const getCurrencyAndVat = () => {
		const combineCurrencyAndVat = vatConfigurations?.map((v) => {
			const currencyName = currencies?.find((c) => v.currencyId === c.id)?.name;

			return { ...v, currencyName };
		});

		const currencyAndVat = combineCurrencyAndVat?.find((el) => el.id === CURRENCY_LIST.AED);

		return currencyAndVat;
	};

	return { getCurrencyAndVat };
};

export default useCurrencyAndVat;
